'use strict';

angular.module('bringgApp').directive('defaultTaskInvoice', function ($translate, $timeout) {
	return {
		restrict: 'E',
		scope: {
			tasks: '=',
			config: '=',
			printedCopies: '=',
			printCallback: '='
		},
		link: function (scope, element, attrs) {
			$timeout(scope.printCallback, 100, true, element);
		},
		templateUrl: 'scripts/features/print/invoices/default-task-invoice.html'
	};
});
